export const COYOTE_VENDOR_ID = '5001b655-4f66-4354-a800-2b1c6d09f068';
export const U_LINE_VENDOR_ID = '055df11a-7e2e-424b-b4c0-221aaf310a06';
export const SUMMIT_VENDOR_ID = 'e580385a-2be8-4d55-a788-76defc433ede';
export const ALFA_VENDOR_ID = 'b3551b68-dd70-4bf1-8852-4e444838f161';

/** RTA supplies every vendor listed here — vendor identifies the brand, not who buys the appliance. */
export const vendorData = [
	{
		id: COYOTE_VENDOR_ID,
		displayValue: 'Coyote',
		description: null,
		active: true
	},
	{
		id: U_LINE_VENDOR_ID,
		displayValue: 'U-Line',
		description: null,
		active: true
	},
	{
		id: SUMMIT_VENDOR_ID,
		displayValue: 'Summit',
		description: null,
		active: true
	},
	{
		id: ALFA_VENDOR_ID,
		displayValue: 'Alfa',
		description: null,
		active: true
	}
];
